import React from 'react';
import PropTypes from 'prop-types';
import DataTable from './DataTable';
import QuickStats from './QuickStats';
import LoadingOverlay from '../LoadingOverlay';
import ResultsWrapper from './ResultsWrapper';
import {
  getOnlineDealsTable,
  getOnlineTotalsTable,
  getCSVFileName,
} from './config';
import ResultsDeals from './ResultsDeals';

function ResultsOnline({
  query,
  deals,
  analytics,
  dealer,
  updatePage,
  updateCustomerName,
  updateFilteredSteps,
}) {
  return (
    <LoadingOverlay active={analytics.fetching}>
      {analytics.data && (
        <div>
          <QuickStats
            stats={[
              {
                label: 'Total Online Opportunities',
                value: analytics.data.totalLeadCount,
                tooltip:
                  'The total number of customers that have submitted PII. Includes lead form, credit app and trade in. This number will differ from Lead Form Captured when the lead form is anywhere but the 1st position.',
              },
              {
                label: 'Online Customized Payments',
                value: analytics.data.paymentBuilder,
                tooltip:
                  'The total number of completed customized payments completed through Upstart Online.',
              },
              {
                label: 'Online Credit App',
                value: analytics.data.creditApplication,
                tooltip:
                  'The total number of online credit apps completed through Upstart Online.',
              },
              {
                label: 'Appointments Set Online',
                value: analytics.data.totalAppointmentCount,
                tooltip:
                  'The total number of appointments set through Upstart Online.',
              },
              ...(dealer?.insurance?.online?.enabled
                ? [
                    {
                      label: 'Online Insurance Applications',
                      value: analytics.data.insurance,
                      tooltip:
                        'The total number of insurance requests submitted through Upstart Online.',
                    },
                  ]
                : []),
            ]}
          />
          <div className="row">
            <div className="col-xs-12">
              <DataTable
                data={[analytics.data]}
                config={getOnlineTotalsTable(dealer)}
                exportCSV
                csvFileName={getCSVFileName(
                  'ProdigyOnlineResults',
                  dealer,
                  query,
                )}
              />
            </div>
          </div>
          <ResultsDeals
            tableDefinition={getOnlineDealsTable(dealer)}
            dealer={dealer}
            page={query.page}
            dealTotal={(deals.data || {}).total || 0}
            dealList={(deals.data || {}).data || []}
            disabled={deals.fetching}
            updatePage={updatePage}
            updateCustomerName={updateCustomerName}
            updateFilteredSteps={updateFilteredSteps}
          />
        </div>
      )}
    </LoadingOverlay>
  );
}

ResultsOnline.propTypes = {
  query: PropTypes.object.isRequired,
  deals: PropTypes.object.isRequired,
  analytics: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
  updatePage: PropTypes.func.isRequired,
  updateCustomerName: PropTypes.func.isRequired,
  updateFilteredSteps: PropTypes.func.isRequired,
};

export default ResultsWrapper(ResultsOnline);
